package dev.lingvo.ops.state

import dev.lingvo.shared.ops.OpsLogScope

fun logFilterSummary(
    operator: String?, action: String, scope: OpsLogScope, since: String, until: String, shown: Int?,
): String {
    if (shown == null) return "No actions loaded yet."
    val clauses = buildList {
        add(
            when (scope) {
                OpsLogScope.WORKSPACE -> "against a workspace"
                OpsLogScope.PLATFORM -> "with no workspace"
                OpsLogScope.ALL -> "of every kind"
            },
        )
        action.trim().takeIf(String::isNotEmpty)?.let(::add)
        if (since.isNotBlank() || until.isNotBlank()) {
            add("from ${since.ifBlank { "the beginning" }} to ${until.ifBlank { "now" }} (UTC, to excluded)")
        }
        operator?.takeIf(String::isNotBlank)?.let { add("by $it") }
    }
    return "Showing $shown action${if (shown == 1) "" else "s"} ${clauses.joinToString(", ")}."
}
